import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const personalDetailsApi = createApi({
  reducerPath: 'personalDetailsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
  }),
  endpoints: (builder) => ({
    getCityFromPincode: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          device_id: data.deviceid,
          auth_token: data.token,
        },
        body: new URLSearchParams({
          mode: 'get_city_from_pincode',
          pin_code: data.pin_code,
          checksum: data.checksum,
        }).toString(),
      }),
    }),

    getSelfieUrl: builder.mutation({
      query: (data) => ({
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          secret: data.scrt,
          jwt_token: data.jwt_token
        },
        body: new URLSearchParams({
          mode: 'get_profile_pic_upload_url',
          checksum: data.checksum,
        }).toString(),
      }),
    }),

    submitMissingDetails: builder.mutation({
      query: (data) => {
        // Body parameters with default values
        const body = {
          email_id: data.email_id || '',
          dob: data.dob || '',
          gender: data.gender || '',
          fathers_name: data.fathers_name || '',
          pan: data.pan || '',
          aadhar_number: data.aadhar_number || '',
          salary: data.salary || '',
          company_name: data.company_name || '',
          gst_number: data.gst_number || '',
          alt_mobile: data.alt_mobile || '',
          rank: data.rank || '0',
          meta_data: JSON.stringify(data.meta_data) || '',
          house_flat_no: data.house_flat_no || '',
          lamf: data.lamf || '',
          address_line_1: data.address_line_1 || '',
          address_line_2: data.address_line_2 || '',
          city: data.city || '',
          pin_code: data.pin_code || '',
          landmark: data.landmark || '',
          //permanent_address_check: data.permanent_address_check || '0',
          current_house_type: data.current_house_type,
          permanent_house_flat_no: data.permanent_house_flat_no || '',
          permanent_address_line_1: data.permanent_address_line_1 || '',
          permanent_address_line_2: data.permanent_address_line_2 || '',
          permanent_city: data.permanent_city || '',
          permanent_pin_code: data.permanent_pin_code || '',
          permanent_landmark: data.permanent_landmark || '',
          salary_date: data.salary_date || '1',
          occupation: data.occupation || '',
          epfo_num: data.epfo_num || '',
          dl_num: data.dl_num || '',
          rc_num: data.rc_num || '',
          marital_status: data.marital_status || '',
          product_id: data.product_id || '',
          mode: 'missing_details',
        };
    
        const checksum = generateChecksum(body);
    
        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            secret: data.scrt,
            jwt_token: data.jwt_token,
            'device_version': data.device_version || '311',
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),

    checkMissingDetails: builder.mutation({
      query: (data) => {
        const body = {
          lamf: data.lamf || '',
          mode: 'check_missing_details'
        }
        const checksum = generateChecksum(body)

        return {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            secret: data.scrt,
            jwt_token: data.jwt_token
          },
          body: new URLSearchParams({ ...body, checksum }).toString(),
        };
      },
    }),

  }),
});

export const {
  useGetCityFromPincodeMutation,
  useGetSelfieUrlMutation,
  useSubmitMissingDetailsMutation,
  useGetBasicDetailsStep1Mutation,
  useCheckMissingDetailsMutation,
} = personalDetailsApi;
